import consultoriasRotas from './consultorias/ConsultoriasRotas'
// import pagamentosRotas from './pagamentos/PagamentosRotas'

export default {
    path: 'gestores',
    name: 'AppSebrae_Consultorias_Gestores',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        consultoriasRotas
        // pagamentosRotas
    ]
}
